const PLACEHOLDER = "https://via.placeholder.com/400?text=Coffee+Beans";

export default function CoffeeGridBoxes({ beans, onClick, ...legacyProps }) {
  const { beansName, roaster, originCountry, roasterCountry, rating, beanspicture } = beans ?? legacyProps;

  return (
    <div
      className={`card transition-colors p-3 ${onClick ? "cursor-pointer hover:border-foreground/30" : ""}`}
      onClick={() => onClick?.(beans ?? legacyProps)}
    >
      <div className="aspect-square w-full mb-3 overflow-hidden rounded">
        <img
          className="w-full h-full object-cover"
          alt={beansName}
          src={beanspicture || PLACEHOLDER}
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = PLACEHOLDER; }}
        />
      </div>
      <div className="space-y-1.5">
        <h3 className="text-foreground text-sm font-medium leading-tight line-clamp-2">{beansName}</h3>
        <p className="text-xs text-muted leading-tight line-clamp-1">{roaster}</p>
        <div className="flex flex-wrap gap-1 pt-0.5">
          {originCountry && originCountry !== "Unknown" && (
            <span className="text-xs px-1.5 py-0.5 rounded bg-border/60 text-foreground">
              {originCountry}
            </span>
          )}
          {roasterCountry && roasterCountry !== "Unknown" && roasterCountry !== originCountry && (
            <span className="text-xs px-1.5 py-0.5 rounded bg-border/40 text-muted">
              {roasterCountry}
            </span>
          )}
        </div>
        {rating && (
          <p className="text-xs text-muted pt-0.5">{rating}/10</p>
        )}
      </div>
    </div>
  );
}
